<style scoped>
.visa-frame {
  margin: 32px
}
@media only screen and (max-width: 480px) {
  .visa-frame {
    margin: 32px 0px 
  }
}
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>

<template>
  <div> 
    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 40%; max-width: 200px">
        <img src="/static/credit-card.svg">
      </div>
    </div>

  
    <div v-if="!paymentDone">
      <div style="padding: 16px"><h2>Payment with an international credit card </h2></div>

      <md-card v-if="cart == 'VISA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Help with your visa application file {{price}}&euro; TTC</div>
            <div class="md-subhead">>Help with your visa application file</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="cart == 'CRRV'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title"> Appeal to the Appeals Board on Visa Refusals {{price}}&euro; TTC</div>
            <div class="md-subhead"> Appeal to the Appeals Board on Visa Refusals.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>

      <md-card v-if="cart == 'TA'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Appeal to the Administrative Court of Nantes {{price}}&euro; TTC</div>
            <div class="md-subhead">Appeal to the Administrative Court of Nantes</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/contract.svg">
          </md-card-media>
        </md-card-header>
      </md-card>


      <md-card v-if="cart == 'PREMIUM'" class="light-frame">
        <md-card-header>
          <md-card-header-text>
            <div class="md-title">Premium Pack {{price}}&euro; TTC</div>
            <div class="md-subhead">You are assisted and defended by a lawyer.</div>
          </md-card-header-text>
          <md-card-media>
            <img src="/static/lawyer.svg">
          </md-card-media>
        </md-card-header>
      </md-card>
      


      <div class="light-frame visa-frame" >
        <!--
        <div class="centered-child" style="">
          <div style="font-weight: bold; font-size: 16px; padding-top: 32px">Do you have any coupon ?</div>
          <md-input-container style="display: inherit; width: 240px; ">
            <md-input placeholder="Coupon de réduction" v-model.trim="coupon" @change="onFetchCouponAmount()"></md-input>
            <span v-if="discount > 0"><img src="/static/checked.svg" style="height: 16px; margin-top: 8px;"></span>
          </md-input-container>
        </div>
-->
        <div class="centered-child">
           <div style="margin-top: 16px">
            <img src="/static/visa.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/mastercard.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/american-express.svg" style="height: 48px; margin: 0px 4px">
            <img src="/static/locked.svg" style="height: 24px; margin: 0px 4px">
          </div>
        </div>


        <div class="centered-child">
          <!-- <form action="/charge" method="post" id="payment-form"> -->
        <div class="form-row" style="width: 80%; min-width: 400px">
          <!-- <label for="card-element">
          </label> -->
          <div id="card-element">
            <!-- a Stripe Element will be inserted here. -->
          </div>

          <!-- Used to display form errors -->
          <div id="card-errors" role="alert"></div>
        </div>

            <!-- <input type="submit" class="submit" value="Submit Payment"> -->
          <!-- </form> -->
        </div>

        <div class="centered-child" style="margin-top: 24px">
          <md-button class="md-raised md-primary large-button" 
          @click="onClickPay()"
          :disabled="loading">
            <span>Payer</span> 
          </md-button>
        </div>

        <div class="centered-child" style="padding: 16px 0px; flex-direction: column; align-items: center">
           <div style="width: 40%; max-width: 100px;">
            <img src="/static/powered_by_stripe.svg">
          </div>
        </div>

      </div>
      
    </div>
    <div v-else>
        <h2>Payment received!</h2>
        
        <div v-if="isFriendPay">
          <p>A confirmation email has just been sent to your friend</p>
          <p>He/She can now continue the creation of your file</p>
          <p>We thank you for your help</p>
        </div>
        
        <div v-else>
          <p>A confirmation email has just been sent to you</p>
          <p>You can now continue the creation of your file.</p>

          <div class="centered-child" style="margin-top: 48px">
            <md-button class="md-raised md-primary large-button"
            @click="onClickContinue()"
            >Continue</md-button>
          </div>
        </div>

    </div>
  </div>
</template>

<script>

import ServiceAccess from '../service/ServiceAccess'

const stripe = global.Stripe('pk_live_x9YLrkFJrCACMzy3yduLQw8E')

export default {
  data: function () {
    return {
      isFriendPay: false,

      cart: null,

      cardNumberInvalid: false,
      cardExpireInvalid: false,
      cardCVCInvalid: false,
      card: {
        number: '',
        expireMonth: '',
        expireYear: '',
        cvc: ''
      },
      coupon: null,
      discount: 0,
      loading: false,
      paymentDone: false
    }
  },



  computed: {
    price: function () {
      let price = 0
      if (this.cart === 'PREMIUM') {
        price = 999
      } else if (this.cart === 'VISA') {
        price = 120
      } else if (this.cart === 'CRRV') {
        price = 299
      } else if (this.cart === 'TA') {
        price = 299
      }
      // return price
      return price - this.discount
    }
  },


  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)


    this.isFriendPay = this.$route.params.sessionId.startsWith('@')
    if (this.isFriendPay) {
      ServiceAccess.instance.purchases(this.$route.params.sessionId).then(purchases => {
        this.cart = purchases[0]
      })
    } else {
      this.cart = this.$route.params.cart
      let promises = [
        ServiceAccess.instance.loadValues(this.$route.params.sessionId)
      ]
      Promise.all(promises).then(responses => {
        let [values] = responses
        this.values = values
      })
    }
  },
  
  mounted: function () {
    const elements = stripe.elements()
    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
    // Create an instance of the card Element.
    this.card = elements.create('card', {style: style})

    this.card.mount('#card-element')
  },

  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      if (this.paymentDone) {
        this.$router.replace('/f/' + this.$route.params.sessionId + '/')
      } else {
        this.$router.back()
      }
    },

    onFetchCouponAmount: function () {
      if (!this.isFetchingCoupon) {
        this.isFetchingCoupon = true
        setTimeout(() => {
          this.isFetchingCoupon = false
          ServiceAccess.instance.fetchCouponAmount(this.coupon, this.cart).then(resp => {
            this.discount = resp
          })
        }, 1000)
      }
      
    },


    onClickPay: async function () {   
      this.loading = true
      const commonErrorMessage = 'Votre carte a été refusée. Nous vous invitons à vérifier et resaisir les informations ou à utiliser une autre carte.'
      try {
        ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-pay', {kind: 'stripe'})
        const paymentMethodResp = await stripe.createPaymentMethod('card', this.card)
        const checkoutResp = await ServiceAccess.instance.checkout(this.$route.params.sessionId, {paymentMethodId: paymentMethodResp.paymentMethod.id, cart: this.cart, coupon: this.coupon})
        if (checkoutResp.error) {
          console.error(checkoutResp)
          global.navigationBarBus.$emit('info', checkoutResp.error.message)    
          ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-stripe-error')
        } else if (checkoutResp.requires_action) {
          const cardAction = await stripe.handleCardAction(checkoutResp.payment_intent_client_secret)
          if (cardAction.error) {
            console.error(cardAction)
            global.navigationBarBus.$emit('info', cardAction.error.message)
            ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-stripe-error') 
          } else {
            await ServiceAccess.instance.checkout(this.$route.params.sessionId, {paymentIntentId: cardAction.paymentIntent.id, cart: this.cart, coupon: this.coupon})
          }
        }

        // success
        ServiceAccess.instance.track(this.$route.params.sessionId, 'checkout-stripe-success')
        this.paymentDone = true
        this.trackAdsConversion()
        // prefetch the purchases
        ServiceAccess.instance.purchases(this.$route.params.sessionId)
      
      } catch (err) {
        console.error('Failed Stripe checkout', err)
        global.navigationBarBus.$emit('info', commonErrorMessage)
      }
      this.loading = false

    },

    trackAdsConversion: function () {
      /* eslint-disable camelcase */
      /* eslint-disable no-unused-vars */
      var google_conversion_id = 865811613
      var google_conversion_language = 'en'
      var google_conversion_format = '3'
      var google_conversion_color = 'ffffff'
      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM'
      var google_remarketing_only = false
      
      var script = document.createElement('script')
      script.src = '//www.googleadservices.com/pagead/conversion.js'

      var image = new global.Image(1, 1)
      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0'
      
      try {
        window.ga('ec:addProduct', {'name': this.cart})
        window.ga('send', 'event', {
          'eventCategory': 'checkout',
          'eventAction': 'checkout-success'
        })
      } catch (err) {}
    },

    entryScreenId: function () {

      if (this.values.id_why === 0) { 
        return 'parcours etudiant'
      } else if (this.values.id_why === 1) {
        return 'parcours conjoint'
      }

      return ''
      
    },


    onClickContinue: function () {
      this.$router.replace('/f/' + this.$route.params.sessionId + '/' + this.entryScreenId())
    }

  }


}
</script>


// WEBPACK FOOTER //
// CheckoutStripe.vue?984818dc